import { lazy } from "react";
import AuthGuard from "routes/AuthGuard";
import Loadable from "routes/Loadable";
import AdminLayout from "components/layouts/adminLayout";

const DirectorList = Loadable(lazy(() => import("pages/director")));
const DirectorDetails = Loadable(lazy(() => import("pages/director/details")));
const DirectorAmount = Loadable(lazy(() => import("pages/director/details/AddDirectorAmount")));
const ReturnDirectorAmount = Loadable(lazy(() => import("pages/director/details/ReturnDirectorAmount")));
const Receipt = Loadable(lazy(() => import("pages/director/details/Receipt")));

const EidBonus = Loadable(lazy(() => import("pages/director/eid-bonus/EidBonus")));
const Honorarium = Loadable(lazy(() => import("pages/director/honorarium/Honorarium")));
const RemunerationCategory = Loadable(lazy(() => import("pages/director/remuneration/RemunerationCategory")));
const AddRemuneration = Loadable(lazy(() => import("pages/director/remuneration/RemunerationAdd")));
const Remuneration = Loadable(lazy(() => import("pages/director/remuneration/Remuneration")));
const AddLandProfit = Loadable(lazy(() => import("pages/director/land-profit/LandProfitAdd")));
const LandProfit = Loadable(lazy(() => import("pages/director/land-profit/LandProfit")));
const ConstructionCharge = Loadable(lazy(() => import("pages/director/construction-charge/ConstructionCharge")));
const AddConstructionCharge = Loadable(lazy(() => import("pages/director/construction-charge/ConstructionChargeAdd")));

const DirectorRoutes = {
  path: "director",
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "list",
      element: <DirectorList />,
    },
    {
      path: "details/:personId",
      element: <DirectorDetails />,
    },
    {
      path: "director-amount/:personId",
      element: <DirectorAmount />,
    },
    {
      path: "director-amount/:personId/receipt/:id",
      element: <Receipt />,
    },
    {
      path: "director-amount/return/:personId",
      element: <ReturnDirectorAmount />,
    },
    {
      path: "eid-bonus",
      element: <EidBonus />,
    },
    {
      path: "honorarium",
      element: <Honorarium />,
    },
    {
      path: "remuneration-category",
      element: <RemunerationCategory />,
    },
    {
      path: "add-remuneration",
      element: <AddRemuneration />,
    },
    {
      path: "remuneration",
      element: <Remuneration />,
    },
    {
      path: "land-profit",
      element: <LandProfit />,
    },
    {
      path: "land-profit/add",
      element: <AddLandProfit />,
    },
    {
      path: "construction-charge",
      element: <ConstructionCharge />,
    },
    {
      path: "construction-charge/add",
      element: <AddConstructionCharge />,
    },
  ],
};

export default DirectorRoutes;
